import React, { useRef, useEffect, useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useOutletContext } from "react-router-dom";
import Scanner from "./Scanner";
import ScanViewfinder from "./ScanViewfinder";
import { matchBarCode } from "./lib/barCode";
import { useNavigate, useLocation, useLoaderData } from "react-router-dom";
import NavBar from "./NavBar";

function barCodeDetected({
    modelData,
    barcode,
    setMatchedTv,
    navigate,
    pathname,
    modelMissCount,
    setModelMissCount,
}) {
    // Sometimes the library misreads the barcode, depends on conditions, so
    // give it five chances in this callback without matching a tv model before
    // we send on to the fail page.

    // Can we match the barcode and get the details of a TV?
    const tvMatch = matchBarCode(modelData, barcode);

    if (!tvMatch && modelMissCount <= 5) {
        // TODO:enhancement: add a dataLayer push here, the scanning library returned a result however we didn't find it in the list
        setModelMissCount(modelMissCount + 1);
        return;
    }

    if (!tvMatch && modelMissCount > 5) {
        // Forward to failure screen
        setModelMissCount(0);
        // Set the matched barcode value to display on the screen.

        return navigate("/no-match", {
            state: { previousPath: pathname, barcode },
        });
    }

    if (tvMatch) {
        // Forward to success
        // The setMatchedTv passes the TV details up to the context of the App component
        // so that it can be used on the success page.
        setModelMissCount(0);
        setMatchedTv(tvMatch);
        return navigate("/tv-match", { state: { previousPath: pathname } });
    }
}

function Scan() {
    useEffect(() => {
        document.title = "HD+ Checker | Scan";
    }, []);

    const [modelMissCount, setModelMissCount] = useState("");

    const modelData = useLoaderData();

    const { setMatchedTv } = useOutletContext();
    const scannerRef = useRef(null);
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return (
        <div
            ref={scannerRef}
            style={{ width: "100%", zIndex: 0 }}
            className="main-container scanner-container"
        >
            <Grid2 container style={{ width: "100%", zIndex: 0 }}>
                <NavBar />
                <canvas
                    className="drawingBuffer"
                    style={{
                        position: "absolute",
                        top: "0px",
                        left: "0px",
                        height: "100vh",
                        width: "100%",
                        objectFit: "cover",
                    }}
                />

                <div
                    style={{
                        position: "absolute",
                        top: "0",
                        bottom: "0",
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                        zIndex: 0,
                    }}
                >
                    <video
                        id="video"
                        autoplay="true"
                        preload="auto"
                        src=""
                        muted="true"
                        playsinline="true"
                        style={{
                            minWidth: "100%",
                            minHeight: "100%",
                            width: "auto",
                            height: "auto",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%,-50%)",
                            zIndex: 0,
                        }}
                    ></video>
                    <ScanViewfinder />
                </div>
                <Scanner
                    scannerRef={scannerRef}
                    onDetected={(barcode) =>
                        barCodeDetected({
                            modelData,
                            barcode,
                            setMatchedTv,
                            navigate,
                            pathname,
                            modelMissCount,
                            setModelMissCount,
                        })
                    }
                />
            </Grid2>
        </div>
    );
}

export default Scan;
